import { FormFields, FormHeader, FormSection } from '../form';
import { Input, YesNoButton } from '../../../../components';
import { useValidation } from '../../../../hooks';
import { useFormContext } from 'react-hook-form';
import { claimFields } from '../../../../config';
import { Dispatch, FC, SetStateAction, useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

interface IRepairsProps {
  setSaveAndQuitChanges?: Dispatch<SetStateAction<Array<string>>>;
}

export const Repairs: FC<IRepairsProps> = ({ setSaveAndQuitChanges }) => {
  const formContext = useFormContext();
  const { fieldRequirements } = useValidation({});
  const { selectedLanguage } = useContext(LanguageSelectorContext);
  const localization = new Localization(selectedLanguage);

  const wereRepairsDoneOnSite: boolean | null = formContext.watch(claimFields.repairsDoneOnSite);

  const onWereRepairsDoneOnSiteNoClick = () => {
    setSaveAndQuitChanges?.((prev) => [
      ...prev,
      claimFields.legacyClaimNo,
      'ClaimComments',
      claimFields.repairsDoneOnSite,
    ]);
    formContext.setValue(claimFields.legacyClaimNo, '');
    formContext.setValue(claimFields.claimComments, '');
    formContext.clearErrors('');
  };

  const onWereRepairsDoneOnSiteYesClick = () => {
    setSaveAndQuitChanges?.((prev) => [...prev, claimFields.repairsDoneOnSite]);
  };

  const onReferenceNumberInputChange = () => {
    setSaveAndQuitChanges?.((prev) => [...prev, 'LegacyClaimNo', claimFields.repairsDoneOnSite]);
    formContext.setValue(claimFields.repairsDoneOnSite, true);
    formContext.clearErrors(claimFields.repairsDoneOnSite);
  };

  return (
    <FormSection>
      <FormHeader>{localization.translate('repairs.header')}</FormHeader>
      <FormFields>
        {/* WERE REPAIRS DONE ONSITE? */}
        <YesNoButton
          isRequired
          isSelected={wereRepairsDoneOnSite}
          labelText={localization.translate('repairs.repairsDoneOnSiteLabel')}
          tooltip={localization.translate('repairs.repairsDoneOnSiteTooltip')}
          name={claimFields.repairsDoneOnSite}
          onNoClick={onWereRepairsDoneOnSiteNoClick}
          onYesClick={onWereRepairsDoneOnSiteYesClick}
        />

        {wereRepairsDoneOnSite !== false && (
          <>
            {/* REFERENCE */}
            <Input
              inputOptions={{
                isRequired: fieldRequirements.LegacyClaimNo,
                label: localization.translate('repairs.referenceLabel'),
                name: claimFields.legacyClaimNo,
                onChange: onReferenceNumberInputChange,
              }}
              tooltip={localization.translate('repairs.referenceTooltip')}
            />
          </>
        )}
      </FormFields>
    </FormSection>
  );
};